module.exports = __webpack_public_path__ + "static/10-449619f2ebd96b91cfe2d2d5e8a77149.png";